<template>
  <div class="w-full bg-[#146297]">
    <div class="container mx-auto relative">
      <div class="mt-2">
        <div class="mx-auto flex flex-col gap-2 mb-2.5">
          <div class="text-white text-3xl lg:text-3xl font-bold mt-5">
            Filter by industry sector
          </div>
        </div>

        <div class="text-white text-sm lg:text-lg font-normal">
          <p>
            AgencyCentral lists 69 popular industries and categorise recruitment agencies based on what they cover, so
            you can easily and quickly find the ones which are most helpful to you.
          </p>
        </div>

        <div class="relative">
          <!-- Popular Industries List -->
          <div :class="{'popular-industries': true, 'hidden': showAllIndustries}">
            <div class="pb-12 mt-2">
              <div class="grid grid-cols-2 lg:grid-cols-4 gap-4">
                <div v-for="(industry, index) in staticIndustries" :key="index">
                  <input-button
                      :block="true"
                      :icon="industry.icon"
                      styleType="search-static-industry"
                      @click="onSelectEmployerOptionClick(index)"
                  >
                    <p>{{ industry.label }}</p>
                  </input-button>
                </div>
                <div>
                  <input-button
                      :block="true"
                      icon="all-industries.png"
                      styleType="all-industries"
                      @click="toggleAllIndustries"
                  >
                    <p>All Industries</p>
                  </input-button>
                </div>
              </div>
            </div>
          </div>

          <!-- All Industries List -->
          <transition name="slide">
            <div
                v-show="showAllIndustries"
                class="slide-transition slide-transition-active inset-x-0 top-0 bg-[#146297] z-10"
            >
              <div class="grid grid-cols-2 lg:grid-cols-3 py-4">
                <div v-for="(industry, index) in allIndustries" :key="index">
                  <a class="text-white text-sm lg:text-base cursor-pointer hover:underline"
                     @click="onSelectEmployerOptionClick(industry.industry_id)">
                    {{ industry.name }}
                  </a>
                </div>
              </div>
              <div class="text-right my-4">
                <a class="text-white cursor-pointer" @click="toggleAllIndustries">Show Less ^</a>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>

  <div v-if="show_description && hasText" class="container mx-auto flex flex-col gap-2 pagetext-content mt-12 mb-8">
    <div class="page-description">
      <ReadMore v-if="show_description && hasText" :text="topText"></ReadMore>
    </div>
  </div>

  <employer-option-select-modal
      :visible="showEmployerOptionSelect"
      :industry="selectedIndustry"
      @onBackgroundClick="onEmployerOptionSelectBackgroundClick"
      @onContentCloseClick="onEmployerOptionSelectClose"
      @selectIndustry="onEmployerOptionSelect"
      @onSearch="(emp_cand) => onSearch(emp_cand)"
  />
</template>


<script>
import InputButton from 'Components/InputButton.vue';
import ReadMore from "Components/PageText/ReadMore.vue";
import EmployerOptionSelectModal from "Components/Modals/EmployerOptionSelectModal.vue";
import validates, { validators } from "Mixins/validates";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: 'IndustryStaticSearchBar',
  components: {
    InputButton,
    ReadMore,
    EmployerOptionSelectModal,
  },
  mixins: [ validates ],
  props: {
    emp_cand: {
      type: String,
      default: null,
    },
    industry: {
      type: String,
      default: null,
    },
    location: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showEmployerOptionSelect: false,
      selectedIndustry: '',
      showAllIndustries: false,
      allIndustries: [],
    };
  },
  computed: {
    ...mapState('pagetext', ['staticIndustries']),
    ...mapGetters('search', ['searchQuery']),
    ...mapGetters('info', [
      'getPopularLocationLinks',
      'getPopularIndustryLinks',
      'getAllIndustryLinks'
    ]),
    hasText() {
      return this.topText !== '';
    },
    hasTitle() {
      return this.title !== '';
    },
    hasSysKeyValue() {
      return this.sysKeyValue !== '';
    },
  },
  methods: {
    ...mapActions('industry', ['getIndustrySkills']),
    ...mapMutations('search', ['setParameter']),
    ...mapMutations('contact', { setRequestorType: 'setType' }),
    async onSelectEmployerOptionClick(industryId) {
      this.showEmployerOptionSelect = true;
      this.selectedIndustry = industryId;
    },
    onEmployerOptionSelectBackgroundClick() {
      this.showEmployerOptionSelect = false;
    },
    onEmployerOptionSelectClose() {
      this.showEmployerOptionSelect = false;
    },
    async onEmployerOptionSelect(industry) {
      this.showEmployerOptionSelect = false;
      if (industry === this.industry) {
        return;
      }
      this.changeParameter('industry', industry);
      this.changeParameter('skill', null);
      await this.getIndustrySkills(industry);
    },
    changeParameter(key, value) {
      delete this.errors[key];
      this.setParameter({key, value});
    },
    toggleAllIndustries() {
      this.showAllIndustries = !this.showAllIndustries;
      if (this.showAllIndustries && this.allIndustries.length === 0) {
        this.fetchAllIndustries();
      }
    },
    fetchAllIndustries() {
      this.allIndustries = this.getAllIndustryLinks;
    },
    async onSearch(emp_cand) {
        this.resetErrors();
        this.changeParameter('emp_cand', emp_cand);
        this.changeParameter('industry', this.selectedIndustry);

        await this.$nextTick();

        let validationRules = {
                    industry: [validators.required],
                    emp_cand: [validators.required],
                    location: [validators.required],
                },
            values = {
                    industry: this.industry,
                    emp_cand: this.emp_cand,
                    location: this.location,
                };
        console.log(values);

        if (!this.validate(validationRules, values)) {
            console.log('validation failed');
            return;
        }

        // always ensure the cookie syncs to the form on submit
        this.setRequestorType(emp_cand);

        this.changeParameter('page', 1);
        console.log(this.searchQuery);
        //return;
        jQuery(document).trigger('tc_search');

        this.link_to({
            name: 'search',
            query: this.searchQuery,
        }, true);

    }
  },
};
</script>
